import axios from "axios";

export const emittedDocApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-emitted-document`,
  headers: { "Content-Type": "application/json" },
});